module.exports = __webpack_public_path__ + "img/west.be5030ca.webp";